import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loaderGenerator" }
const _hoisted_2 = { class: "loaderGeneratorContent" }
const _hoisted_3 = { class: "loaderGenerateProjListContainer" }
const _hoisted_4 = { class: "loaderGenerateTaskContainer" }

import LoaderGenerateConfig from "@/components/loaderGenerator/loaderGenerateConfig.vue";
import LoaderGenerateTask from "@/components/loaderGenerator/loaderGenerateTask.vue";
import LoaderGenerateProjList from "@/components/loaderGenerator/loaderGenerateProjList.vue";

import { defineComponent } from 'vue';
const __default__ = defineComponent({
        name: "LoaderGeneratorLog"
    }
)


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(LoaderGenerateProjList)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(LoaderGenerateTask)
      ])
    ])
  ]))
}
}

})